
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Company } from '../types';

interface EditCompanyModalProps {
  company: Company;
  onClose: () => void;
  onSubmit: (data: Partial<Company>) => void;
}

const EditCompanyModal: React.FC<EditCompanyModalProps> = ({ company, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: company.name,
    plan: company.plan,
    userLimit: company.userLimit
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Fire and Forget : on met à jour instantanément
    onSubmit(formData);
    onClose();
  };

  const modalContent = (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-6 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
      <div className="absolute inset-0" onClick={onClose}></div>
      <div className="relative bg-white dark:bg-slate-900 w-full max-w-lg rounded-[3rem] shadow-2xl p-10 border border-slate-200 dark:border-slate-800 animate-in zoom-in-95">
        <h3 className="text-2xl font-black mb-2 dark:text-white tracking-tight">Modifier Entité</h3>
        <p className="text-slate-500 mb-8 text-sm">Ajustez les paramètres de l'abonnement.</p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Nom Société</label>
                <input required type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-bold outline-none focus:ring-2 focus:ring-indigo-500" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Plan</label>
                    <select value={formData.plan} onChange={e => setFormData({...formData, plan: e.target.value as any})} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-bold outline-none">
                        <option value="BASIC">BASIC</option>
                        <option value="PRO">PRO</option>
                        <option value="ENTERPRISE">ENTERPRISE</option>
                    </select>
                </div>
                <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Licences Max</label>
                    <input type="number" value={formData.userLimit} onChange={e => setFormData({...formData, userLimit: parseInt(e.target.value)})} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-bold outline-none" />
                </div>
            </div>
          </div>
          
          <div className="flex gap-4 pt-4">
            <button type="button" onClick={onClose} className="flex-1 py-4 text-xs font-black text-slate-400 uppercase tracking-widest hover:text-slate-600 transition-colors">Annuler</button>
            <button type="submit" className="flex-1 py-4 bg-indigo-600 text-white rounded-2xl text-xs font-black shadow-xl shadow-indigo-600/30 uppercase tracking-widest hover:bg-indigo-700 transition-all flex items-center justify-center gap-2">
               Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default EditCompanyModal;
